import { Component, Input } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html'
})
export class SuccessModalComponent {
  @Input() message: string;
  @Input() model: any;
  @Input() modalRef: NgbModalRef | null;

  constructor(private readonly modalService: NgbModal) {}

  onClickOk() {
    if (this.modalRef) {
      this.modalRef?.close();
    } else {
      this.modalService.dismissAll();
    }
  }
}
